var _rect, _g, _g2, _path, _g3, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_283_18163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_283_18163)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_283_18163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2102 6.13153L30.3193 11.6523L22.8638 14.3759L23.9787 6.51636C24.0633 5.92058 24.8015 5.68988 25.2102 6.13153Z",
    fill: "url(#paint0_linear_283_18163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44626 16.3119L15.5897 18.95L9.90478 24.4893L7.51997 17.2042C7.33412 16.6364 7.88586 16.105 8.44626 16.3119Z",
    fill: "url(#paint1_linear_283_18163)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_283_18163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0754 18.9126L32.6053 3.74705C32.3712 3.19832 31.6074 3.16139 31.3215 3.68498L27.3826 10.8974C27.0842 11.4437 26.414 11.666 25.8483 11.4063L12.2853 5.17972C11.7949 4.95459 11.2416 5.33359 11.2743 5.87217L12.1385 20.0989C12.1808 20.7958 11.6146 21.378 10.9168 21.355L1.43659 21.0433C0.820562 21.023 0.469238 21.7372 0.865901 22.2089C4.13557 26.0977 9.41586 32.2441 11.9922 35.4433C12.6906 36.3105 13.8151 36.7452 14.8975 36.4842C27.8714 33.3565 35.844 25.7789 38.8796 21.3922C39.3842 20.6629 39.4234 19.7283 39.0754 18.9126Z",
    fill: "url(#paint2_linear_283_18163)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_283_18163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 40,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7994 18.2658L32.6053 3.74705C32.3712 3.19832 31.6074 3.16139 31.3215 3.68498L27.3826 10.8974C27.0842 11.4437 26.414 11.666 25.8483 11.4063L12.2853 5.17972C11.7949 4.95459 11.2416 5.33359 11.2743 5.87217L12.1385 20.0989C12.1808 20.7958 11.6146 21.378 10.9168 21.355L1.43659 21.0433C0.820562 21.023 0.469238 21.7372 0.865901 22.2089C3.90771 25.8267 8.68965 31.3984 11.4158 34.7333C12.4728 36.0263 14.1657 36.6842 15.7816 36.2623C27.6951 33.1516 35.2397 26.3056 38.4679 21.9654C39.2618 20.898 39.3214 19.4893 38.7994 18.2658Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_283_18163)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_283_18163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2012 1.62793C31.06 6.92956 29.4745 14.4752 24.8809 10.8151C26.0285 9.30759 30.3175 4.01301 32.2012 1.62793Z",
    fill: "url(#paint3_linear_283_18163)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_283_18163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.714844 21.0776C5.98744 22.3462 13.5184 24.5088 11.9753 18.9305C10.1194 19.3117 3.68058 20.4133 0.714844 21.0776Z",
    fill: "url(#paint4_linear_283_18163)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6214 24.4182C26.5361 24.4757 26.4359 24.511 26.3086 24.5215L24.3442 24.7043C24.2936 24.706 24.2339 24.7248 24.1771 24.7631C24.1274 24.7967 24.0806 24.8498 24.0551 24.8886L23.1628 26.6446C23.1125 26.754 23.0423 26.8337 22.9429 26.9008C22.7725 27.0158 22.5541 27.0446 22.3505 26.9879C22.1469 26.9313 21.9843 26.7822 21.8927 26.5852L21.0497 24.7388C20.9939 24.6255 20.8884 24.5458 20.7673 24.5196L18.8319 24.1329C18.5586 24.0801 18.3418 23.8814 18.2628 23.6112C18.1838 23.341 18.2563 23.0656 18.4515 22.88L19.8772 21.562C19.9666 21.4801 20.0139 21.3511 19.9965 21.2334L19.6866 19.2428C19.646 18.9683 19.7599 18.7082 19.98 18.5596C20.2002 18.411 20.484 18.4028 20.7234 18.5431L22.4535 19.5752C22.5682 19.6379 22.6935 19.6397 22.8029 19.5874L24.5586 18.7583C24.8037 18.6468 25.0862 18.6826 25.3022 18.8495C25.5233 19.0238 25.6265 19.2992 25.5802 19.5677L25.2269 21.5098C25.1988 21.6366 25.2404 21.7595 25.3246 21.8536L26.7094 23.3236C26.8579 23.4822 26.9352 23.6888 26.9116 23.8988C26.9001 24.1115 26.7918 24.3032 26.6214 24.4182Z",
    fill: "url(#paint5_linear_283_18163)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_283_18163",
    x: 7.48242,
    y: 5.90186,
    width: 22.8359,
    height: 18.5874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.888682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.911784 0 0 0 0 0.950011 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_283_18163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_283_18163",
    x: 0.697266,
    y: 3.31299,
    width: 38.6055,
    height: 35.0239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.36982
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.888682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.935742 0 0 0 0 0.965729 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_283_18163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_283_18163",
    x: 24.8809,
    y: 1.62793,
    width: 9.09768,
    height: 10.1533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.77736
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0368
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.64757 0 0 0 0 0.765359 0 0 0 0 0.935498 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_283_18163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_283_18163",
    x: 0.714844,
    y: 18.9307,
    width: 13.2422,
    height: 3.64111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.77736
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0368
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.64757 0 0 0 0 0.765359 0 0 0 0 0.935498 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_283_18163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_283_18163",
    x1: 15.3904,
    y1: 10.562,
    x2: 19.4916,
    y2: 16.8238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#C4D9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AA1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_283_18163",
    x1: 15.3904,
    y1: 10.562,
    x2: 19.4916,
    y2: 16.8238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#C4D9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AA1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_283_18163",
    x1: 35.8442,
    y1: 12.1073,
    x2: 7.06943,
    y2: 29.8739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175343,
    stopColor: "#D2E1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322647,
    stopColor: "#B7CDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665958,
    stopColor: "#EBF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986264,
    stopColor: "#B4C8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_283_18163",
    x1: 29.3621,
    y1: 7.66611,
    x2: 26.6293,
    y2: 12.1574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADC8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_283_18163",
    x1: 7.28188,
    y1: 21.3601,
    x2: 12.3735,
    y2: 20.7068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADC8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_283_18163",
    x1: 19.9992,
    y1: 18.5772,
    x2: 24.9802,
    y2: 24.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A98D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98BEEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown2);
export default __webpack_public_path__ + "static/media/crown_2.2e8a82e5cb63fb21fdeebf62e4bc4cc9.svg";
export { ForwardRef as ReactComponent };